import styled from "styled-components";
const Paragraph = styled.p `
  color: ${props => props.theme.tertiary};
  font-family: ${props => props.theme.fontBase};
  font-weight: 400;
  font-size: 17px;
  margin: 0;
`;
export default Paragraph;
